export default {
      id: "card-logo-vip-usage",
      viewBox: "0 0 65 64",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#card-logo-vip",
      toString: function () {
        return this.url;
      }
    }